export const OFFLINE_PAGE_PATH = '/offline';

export const OAUTH_NAVIGATION_PATHS = new Set([
  '/oauth/google/ads',
  '/oauth/google/calendar',
  '/oauth/google/web-analytics',
  '/oauth/google/mailbox',
  '/oauth/meta',
]);
